import { ThemeProvider } from "@mui/material";
import { NotificationsWrapper } from "@designboticteam/react/features";
import { muiTheme } from "../../config/muiTheme";
import { EngineComponent, EngineContext, EngineGate } from "../../engine";
import { SidePanel } from "./SidePanel";

const MapPage = () => {
	return (
		<ThemeProvider theme={muiTheme}>
			<NotificationsWrapper>
				<EngineContext>
					<EngineComponent />

					<EngineGate>
						<SidePanel />
					</EngineGate>
				</EngineContext>
			</NotificationsWrapper>
		</ThemeProvider>
	);
};

export { MapPage };
